<template>
  <div class="bg-blue-500 h-full flex items-center overflow-auto pattern">
    <div class="container mx-auto h-full lg:flex items-center w-4/5 md:w-3/5 lg:w-full">
      <div class="lg:w-1/2 border-b-2 lg:border-b-0 lg:border-r-2 border-blue-400">
        <div class="text-gray-300 text-lg lg:text-3xl font-thin pt-16 pb-6 lg:pb-16 leading-lose text-center lg:text-left">
          <p class="text-3xl lg:text-5xl text-blue-200 font-medium mb-4 ">
            Aim High<span class="text-4xl lg:text-6xl">&nbsp;|&nbsp;</span>Dream Big
          </p>
          <p class="mt-2 inline-block ">
            We are really glad to be a part of your journey.
          </p>
          <br>
          <p class="mt-2 inline-block ">
            Your success is what it all matters most to us.
          </p>
        </div>
      </div>
      <div
        class="lg:w-1/2 flex flex-col flex-end justify-start lg:justify-center items-center mt-8 lg:mt-16"
      >
        <form
          class="bg-white border mb-6 shadow p-8 rounded-lg w-full lg:w-3/5"
          method="POST"
          @submit.prevent="attempt"
        >
          <div class="flex flex-col mb-8">
            <div class="text-gray-700 flex flex-col">
              <img
                id="logo"
                :src="tenant.logo"
                :alt="tenant.business_name"
                v-if="tenant.logo"
                @error="hideLogoBlock"
                class="rounded shadow-inset mb-6"
                style="height: 100px;width: 200px;align-self: center"
              />
              <p class="font-medium text-2xl">Welcome to Client Portal</p>
              <span class="inline-block border-2 border-blue-400 w-24"></span>
            </div>
          </div>
          <div
            class="bg-red-100 border border-red-400 text-red-700 px-3 py-3 rounded mb-6"
            v-if="message"
          >
            <span class="font-bold">{{ message }}</span>
          </div>
          <div class="mb-6">
            <AgInput
              v-validate
              label="Email Address"
              name="email"
              v-model="credentials.email"
              placeholder="Enter your email address"
              :has-error="errors.has('email')"
            >
              <span class="text-sm text-red-600">{{
                errors.first('email')
              }}</span>
            </AgInput>
          </div>
          <div class="mb-8">
            <AgInput
              v-validate
              label="Password"
              name="password"
              v-model="credentials.password"
              placeholder="******************"
              type="password"
              :has-error="errors.has('password')"
            >
              <span class="text-sm text-red-600">{{
                errors.first('password')
              }}</span>
            </AgInput>
          </div>
          <div class="flex items-center justify-between">
            <button
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
              @click="attempt"
            >
              Sign In
            </button>
            <router-link
              tag="a"
              to="/reset-password"
              class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
              exact
            >
              Forgot Password?
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AgInput from '@/components/Input/Input.vue';

export default {
  name: 'Login',
  components: {
    AgInput
  },
  props: {
    tenant: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      message: '',
      credentials: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    hideLogoBlock() {
      let imageBlock = document.getElementById('div1');
      imageBlock.classList.add('hidden');
    },
    attempt() {
      this.message = '';
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$loading(true);
          axios
            .post('/', this.credentials)
            .then(response => {
              if (response.status === 200) {
                window.location =
                  window.location.href.replace(/\/$/, '') + '/dashboard';
              }
            })
            .catch(error => {
              this.$loading(false);
              const errors = error.response.data;
              const status = error.response.status;
              if (status === 422) {
                let errorFields = Object.keys(errors);
                for (let i = 0; i < errorFields.length; i++) {
                  let field = errorFields[i];

                  let errorString = errors[field][0];
                  this.$validator.errors.add({
                    field: field,
                    msg: errorString
                  });
                }
                return;
              }
              this.message = error.response.data.data.message;
            });
        }
      });
    }
  }
};
</script>
<style>
.pattern {
  background-image: url('./../../assets/bg_login.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
